import React from 'react';
import { Container } from 'react-bootstrap';

const TaskComplete = () => {
    return (
        <Container>
            <div className='text-center'>
                <h2>We have received your results!</h2>
                <p>Thanks for participation.</p>
            </div>
        </Container>
    );
}

export default TaskComplete;